import React from "react";
import Modal from "components/ui/Modal";
import ChangePassword from "pages/user-settings/my-profile/ChangePassword";

const ChangePasswordPage = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className="sm:max-w-[400px] w-full" title={<span className="py-2">Change Password</span>}>
      <hr className="border-b border-[rgb(88,88,80,50%)]" />
      <div className="ml-4 mr-4 mt-2">
        <ChangePassword isDialog />
      </div>
    </Modal>
  );
};

export default ChangePasswordPage;
